import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { SearchIcon, MenuIcon, XIcon } from 'lucide-react';
const ARTICLE_PATH = '/news/don-callaway-ferrari-case';
interface NavLinkItem {
  label: string;
  to: string;
}
const NAV_LINKS: NavLinkItem[] = [{
  label: 'News',
  to: ARTICLE_PATH
}, {
  label: 'California',
  to: ARTICLE_PATH
}, {
  label: 'Legal',
  to: ARTICLE_PATH
}, {
  label: 'Business',
  to: ARTICLE_PATH
}, {
  label: 'Automotive',
  to: ARTICLE_PATH
}, {
  label: 'About',
  to: ARTICLE_PATH
}];
export function SiteHeader() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  return <header className="sticky top-0 z-40 w-full border-b border-rule bg-paper/95 backdrop-blur" data-id="element-65" data-mp="14u29vsvigr2h">
      <div className="mx-auto flex h-16 max-w-shell items-center gap-6 px-5 sm:px-8" data-id="element-66" data-mp="zzomacn3bo8d">
        <Link to={ARTICLE_PATH} className="font-sans text-[15px] font-bold uppercase tracking-[0.18em] text-ink whitespace-nowrap" data-id="element-67" data-mp="2gdoipdmq8vqv">
          California News
        </Link>

        <nav aria-label="Sections" className="ml-6 hidden flex-1 lg:block" data-id="element-68" data-mp="29lwlb2alfzlc">
          <ul className="flex items-center gap-7" data-id="element-69" data-mp="2ehbxlpsydnfn">
            {NAV_LINKS.map(link => <li key={link.label} data-id="element-70" data-mp="2jjb2j44ccsep">
                <Link to={link.to} aria-current={pathname === link.to ? 'page' : undefined} className="font-sans text-[13px] font-medium text-ink-soft transition-colors duration-150 ease-out hover:text-ink focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ink focus-visible:ring-offset-4" data-id="element-71" data-mp="2jg5eztbd1yl3">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </nav>

        <div className="ml-auto flex items-center gap-1" data-id="element-72" data-mp="25kbf1zskejk4">
          <button type="button" aria-label="Search" className="flex h-9 w-9 items-center justify-center text-ink-soft transition-colors duration-150 ease-out hover:text-ink focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ink" data-id="element-73" data-mp="181rw72vgs9bx">
            <SearchIcon className="h-[18px] w-[18px]" strokeWidth={1.6} data-id="element-74" data-mp="1013piq3zclb2" />
          </button>
          <button type="button" aria-label={mobileOpen ? 'Close menu' : 'Open menu'} aria-expanded={mobileOpen} onClick={() => setMobileOpen(open => !open)} className="flex h-9 w-9 items-center justify-center text-ink-soft transition-colors duration-150 ease-out hover:text-ink focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ink lg:hidden" data-id="element-75" data-mp="1erazehfx8w05">
            {mobileOpen ? <XIcon className="h-5 w-5" strokeWidth={1.6} data-id="element-76" data-mp="r1gm5yrox5fd" /> : <MenuIcon className="h-5 w-5" strokeWidth={1.6} data-id="element-77" data-mp="r3jmbbmk4ext" />}
          </button>
        </div>
      </div>

      {mobileOpen && <nav aria-label="Sections" className="border-t border-rule bg-paper lg:hidden" data-id="element-78" data-mp="22h5aatgokahr">
          <ul className="mx-auto max-w-shell px-5 py-2 sm:px-8" data-id="element-79" data-mp="2a0ehqh5mlz46">
            {NAV_LINKS.map(link => <li key={link.label} className="border-b border-rule last:border-b-0" data-id="element-80" data-mp="2ezr5r588hc8c">
                <Link to={link.to} onClick={() => setMobileOpen(false)} className="block py-3 font-sans text-[14px] font-medium text-ink-soft transition-colors duration-150 ease-out hover:text-ink" data-id="element-81" data-mp="20zq3blcblwqr">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </nav>}
    </header>;
}